import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import Switch from "@mui/material/Switch";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class TeamsList extends Component {
  state = {
    teams: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllTeams(this.state.page_no, this.state.per_page);
  }

  getAllTeams = async (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    try {
      const resp = await axios.post(Constants.getUrls.getAllTeams, {
        page,
        limit,
      });

      if (resp.data?.status === true) {
        const data = resp.data.data || [];

        const pagination = {
          page: resp.data.page || page,
          limit: resp.data.limit || limit,
          totalDocs: resp.data.total || data.length,
          totalPages:
            resp.data.totalPages ||
            Math.ceil((resp.data.total || data.length) / limit),
          hasNextPage: resp.data.hasNextPage,
          hasPrevPage: resp.data.hasPrevPage,
        };

        this.setState({
          teams: data.rows || data,
          pagination,
          page_no: pagination.page,
          loading: false,
        });
      } else {
        this.setState({
          notification: true,
          message: resp.data?.message || "Failed to load teams",
          notiColor: "warning",
          loading: false,
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  handleStatusChange = async (id, currentStatus) => {
    if (init() !== "success") return;

    const newStatus = currentStatus === 1 ? 0 : 1;

    try {
      const resp = await axios.put(Constants.putUrls.changeTeamStatus, {
        id,
        status: newStatus,
      });

      if (resp.data.status) {
        this.setState({
          notification: true,
          message: resp.data.message || "Status updated",
          notiColor: "success",
        });

        // refresh
        this.getAllTeams(this.state.pagination.page, this.state.per_page);
      } else {
        this.setState({
          notification: true,
          message: resp.data.message || "Failed",
          notiColor: "warning",
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Status update failed!",
        notiColor: "warning",
      });
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllTeams(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllTeams(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this team member?"))
      return;

    axios
      .post(Constants.deleteUrls.deleteTeam, { id })
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Team member deleted",
          },
          () => {
            this.getAllTeams(this.state.pagination.page, this.state.per_page);
          },
        );
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Delete failed",
        });
      });
  };

  render() {
    const { teams, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Team Members
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right">
              <Link to="/addteams">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : teams && teams.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Name", accessor: "name" },
                      { Header: "Position", accessor: "position" },
                      { Header: "Image", accessor: "image" },
                      // { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: teams.map((member, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit + (index + 1),
                      name: member.name || "—",
                      position: member.description.substring(0, 30) || "—",
                      image: member.image_path ? (
                        <img
                          src={Constants.imageDomain + member.image_path}
                          alt={member.name}
                          style={{
                            height: "60px",
                            width: "100px",
                            objectFit: "cover",
                            borderRadius: 6,
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            height: 60,
                            width: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f5f5f5",
                            borderRadius: 6,
                          }}
                        >
                          No Image
                        </div>
                      ),
                      // status: (
                      //   <Switch
                      //     checked={member.status === 1}
                      //     onChange={() =>
                      //       this.handleStatusChange(member.id, member.status)
                      //     }
                      //     color="success"
                      //   />
                      // ),
                      action: (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <Tooltip title="Edit Member" placement="top">
                            <Link
                              to={{
                                pathname: `/updateteams/${member.id}`,
                                state: { data: member },
                              }}
                            >
                              <IconButton color="info" size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete Member" placement="top">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(member.id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Teams Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
